export default {
  spaServiceLabel: "Soin spa",
  fitnessClassLabel: "Cours de fitness",
  selectedTime: "Horaire sélectionné",

  tbd: "À définir",
  durationUnavailable: "Durée indisponible",
  "checkoutCancelled": "Paiement annulé",
  "checkoutCancelledHelp": "La page de paiement non réglé est fermée. Vous pouvez revenir et choisir un autre mode de paiement.",
  "backToBooking": "Retour à la réservation",

  "recoveryCheck": "Vérifier le résultat de la réservation",
  "recoveryChecking": "Vérification du résultat…",
  "recoveryExplain": "Vérifiez le résultat avant de réessayer. Toute procédure de paiement non réglé sera fermée en toute sécurité.",
  "recoveryPending": "Le résultat est toujours en attente. Vérifiez à nouveau avant de commencer une autre réservation.",
  "recoveryHelp": "Le paiement nécessite l’intervention du club. Contactez le club avant de réserver à nouveau.",

  "noPayment": "Aucun paiement requis",
  "spaSuccess": "Votre soin est réservé",
  "fitnessSuccess": "Votre inscription est confirmée",
  "racquetSuccess": "Votre court est réservé",
  "reservationConfirmed": "Réservation confirmée",
  "welcome": "Tout est prêt. Nous avons hâte de vous accueillir.",
  "viewBooking": "Afficher la réservation",
  "backHome": "Retour à l’accueil",
  "reference": "Référence de réservation",
  "paymentLabel": "Paiement",
  "confirmed": "Confirmé",
  "guests": "Invités",
  "alreadyBooked": "Vous avez déjà ce rendez-vous. Consultez vos prochaines réservations.",
  "popup": "Veuillez autoriser les fenêtres contextuelles pour accéder au paiement sécurisé.",
  "accounting": "Impossible de finaliser votre réservation, car la synchronisation du compte a échoué. Veuillez réessayer.",
  "fitnessGeneric": "Impossible de traiter cette demande. Veuillez réessayer ou contacter le club.",
  "fitnessAlreadyBooked": "Vous êtes déjà inscrit à ce créneau de cours.",
  "fitnessAccounting": "Impossible de finaliser votre réservation. Veuillez réessayer ou contacter le club.",

  "total": "Total",
  "confirm": "Confirmer la réservation",
  "confirming": "Confirmation…",
  "checking": "Vérification des disponibilités…",
  "chooseTime": "Veuillez revenir en arrière et choisir un créneau disponible.",
  "pending": "Vérifiez votre paiement ou vos prochaines réservations avant de commencer une autre réservation.",
  "unknown": "Impossible de vérifier le résultat de la réservation. Consultez vos prochaines réservations ou contactez le club avant de réessayer.",
  "unavailable": "Ce créneau n’est plus disponible. Veuillez en choisir un autre.",
  "invalid": "Ce créneau n’est plus disponible. Veuillez revenir en arrière et en choisir un autre.",
  "failed": "Impossible de confirmer cette réservation pour le moment.",
  "previewFailed": "Impossible de vérifier ce créneau. Veuillez revenir en arrière et réessayer.",
  "serviceFailed": "Impossible de charger ce soin. Veuillez revenir en arrière et réessayer.",
  "backTimes": "Retour aux créneaux disponibles",
  "backClasses": "Retour aux cours",
  "review": "Vérifier et confirmer",
  "attendee": "Participant",
  "payer": "Payeur",
  "member": "Membre",
  "details": "Détails de la réservation",
  "class": "Cours",
  "date": "Date",
  "time": "Heure",
  "location": "Lieu",
  "confirmClass": "Confirmer votre cours",
  "fitnessBooking": "Réservation de fitness",
  "session": "Session",
  "payment": "Mode de paiement",
  "account": "Compte membre",
  "statement": "Les frais sont ajoutés à votre relevé de compte membre.",
  "secure": "Payer maintenant en toute sécurité.",
  "guestPay": "L’invité paiera",
  "guestLink": "Envoyer un lien de paiement sécurisé à l’invité par e-mail. Votre compte membre ne sera pas débité."
}
